var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Collapse, FormControl, IconButton, Input, InputAdornment, Link, List, ListItem, ListItemButton, ListItemText, styled, } from '@mui/material';
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon, Search as SearchIcon } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
var empty = {};
var CategoryList = styled(List)(function (_a) {
    var theme = _a.theme;
    return ({
        overflow: 'auto',
        height: '100%',
        padding: 0,
    });
});
var CategoryItem = styled(ListItemButton)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4)
        },
        _b[theme.breakpoints.down('md')] = {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
        _b.paddingTop = theme.spacing(1),
        _b.paddingBottom = theme.spacing(1),
        _b.display = 'flex',
        _b.alignItems = 'center',
        _b);
});
var CategoryText = styled(ListItemText)(function (_a) {
    var theme = _a.theme;
    return ({
        marginLeft: theme.spacing(2),
        span: { fontWeight: 'bold' },
    });
});
var CategoryItemsList = styled(List)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4)
        },
        _b[theme.breakpoints.down('md')] = {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
        _b['& .MuiListItem-root'] = { paddingLeft: theme.spacing(7) },
        _b);
});
var ClosedIconsContainer = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        marginTop: 64,
    });
});
var ClosedIcon = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
    });
});
var SearchContainer = styled(FormControl)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            padding: theme.spacing(4),
            paddingTop: 0
        },
        _b[theme.breakpoints.down('md')] = {
            padding: theme.spacing(2),
            paddingTop: 0,
        },
        _b);
});
export var MenuList = React.memo(function (props) {
    var open = props.open, setOpen = props.setOpen;
    var _a = useState(''), search = _a[0], setSearch = _a[1];
    var _b = useState(empty), closed = _b[0], setClosed = _b[1];
    var searchLower = search.toLowerCase();
    var menu = useSelector(function (state) { return state.session.headerMenu; }) || [];
    var searchRef = useRef(null);
    useEffect(function () {
        /**
         * on open left menu, set the focus to the search input field
         */
        if (open && searchRef.current) {
            searchRef.current.focus();
        }
    }, [open, searchRef]);
    var filteredMenu = search
        ? menu
            .map(function (category) { return (__assign(__assign({}, category), { items: category.items.filter(function (item) { return item.title.toLowerCase().includes(searchLower) || item.link.toLowerCase().includes(searchLower); }) })); })
            .filter(function (category) { return category.items.length; })
        : menu;
    return (_jsx(_Fragment, { children: open ? (_jsxs(_Fragment, { children: [_jsx(SearchContainer, __assign({ fullWidth: true }, { children: _jsx(Input, { placeholder: "Search", endAdornment: _jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(SearchIcon, {}, void 0) }), void 0), value: search, onChange: function (e) {
                            setSearch(e.target.value);
                            setClosed(empty);
                        }, onKeyDown: function (e) {
                            if (e.key === 'Enter' && filteredMenu.length === 1 && filteredMenu[0].items.length === 1) {
                                window.location.href = filteredMenu[0].items[0].link;
                            }
                        }, inputRef: searchRef }, void 0) }), void 0), _jsx(CategoryList, __assign({ dense: true }, { children: filteredMenu.map(function (category) { return (_jsxs(React.Fragment, { children: [_jsxs(CategoryItem, __assign({ onClick: function () {
                                    var _a;
                                    return setClosed(__assign(__assign({}, closed), (_a = {}, _a[category.title] = !closed[category.title], _a)));
                                } }, { children: [_jsx(IconButton, __assign({ edge: "start", disableRipple: true, style: { backgroundColor: 'transparent' } }, { children: _jsx("img", { className: "themed-svg", width: "24", src: category.icon, alt: "" }, void 0) }), void 0), _jsx(CategoryText, { children: category.title }, void 0), closed[category.title] ? _jsx(ExpandMoreIcon, {}, void 0) : _jsx(ExpandLessIcon, {}, void 0)] }), void 0), _jsx(Collapse, __assign({ in: !closed[category.title] }, { children: _jsx(CategoryItemsList, __assign({ dense: true }, { children: category.items.map(function (item) { return (_jsx(ListItem, __assign({ button: true, component: Link, href: item.link }, { children: _jsx(ListItemText, { children: item.title }, void 0) }), item.title)); }) }), void 0) }), void 0)] }, category.title)); }) }), void 0)] }, void 0)) : (_jsx(ClosedIconsContainer, { children: menu.map(function (category) { return (_jsx(ClosedIcon, { children: _jsx(IconButton, __assign({ edge: "start", onClick: function () {
                        setClosed(menu.reduce(function (acc, c) {
                            acc[c.title] = c.title !== category.title;
                            return acc;
                        }, {}));
                        setOpen(true);
                    } }, { children: _jsx("img", { className: "themed-svg", width: "24", src: category.icon, alt: "" }, void 0) }), void 0) }, category.title)); }) }, void 0)) }, void 0));
});
